module.exports = __webpack_public_path__ + "img/district01.6a61dac8.jpg";